document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('.product-carousel');
  carousels.forEach(carousel => {
    const inner = carousel.querySelector('.product-carousel__inner');
    const cards = inner.querySelectorAll('.product-card');
    if (cards.length === 0) return;
    const carouselWidth = carousel.getBoundingClientRect().width;
    const cardWidth = cards[0].getBoundingClientRect().width;
    const visibleCards = Math.floor(carouselWidth / cardWidth);
    let currentIndex = 0;
    let startX = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;
    let isDragging = false;

    const updateCarousel = () => {
      currentTranslate = -currentIndex * visibleCards * cardWidth;
      prevTranslate = currentTranslate;
      inner.style.transform = `translateX(${currentTranslate}px)`;
    };

    const nextSlide = () => {
      const maxIndex = Math.ceil(cards.length / visibleCards) - 1;
      if (currentIndex < maxIndex) {
        currentIndex++;
        updateCarousel();
      }
    };

    const prevSlide = () => {
      if (currentIndex > 0) {
        currentIndex--;
        updateCarousel();
      }
    };

    // Arrow navigation
    carousel.querySelector('.carousel-arrow--left').addEventListener('click', prevSlide);
    carousel.querySelector('.carousel-arrow--right').addEventListener('click', nextSlide);

    // Swipe functionality
    inner.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
      inner.style.transition = 'none'; // Disable transition during drag
    });

    inner.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      const currentX = e.touches[0].clientX;
      const diffX = currentX - startX;
      currentTranslate = prevTranslate + diffX;
      inner.style.transform = `translateX(${currentTranslate}px)`;

      // Prevent vertical scrolling while swiping
      e.preventDefault();
    });

    inner.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      isDragging = false;
      inner.style.transition = 'transform 0.5s ease-in-out'; // Re-enable transition

      const endX = e.changedTouches[0].clientX;
      const diffX = startX - endX;

      // Swipe threshold (e.g., 30px for better sensitivity)
      if (diffX > 30) {
        nextSlide();
      } else if (diffX < -30) {
        prevSlide();
      } else {
        // Snap back to current position if swipe is too small
        updateCarousel();
      }
    });

    // Prevent dragging from causing issues on desktop
    inner.addEventListener('dragstart', (e) => e.preventDefault());
  });
});